import { Auth0ContextInterface, User } from "@auth0/auth0-react"

let auth0: Auth0ContextInterface<User> | null = null

export const setAuth0 = (auth0Instance: Auth0ContextInterface<User>) => {
  auth0 = auth0Instance
}

export const getAuth0 = (): Auth0ContextInterface<User> => {
  if (!auth0) {
    throw new Error("Auth0 has not been initialized. Call setAuth0 first.")
  }
  return auth0
}
